import React from 'react';
import { translate } from '../../i18n';

type WeatherInfoData = {
  heading?: string;
  expectedTemp?: string;
  ofl?: string | null;
  forecastStatus?: string;
  information?: string;
  note?: string;
  lastUpdated?: string;
};

interface WeatherInfoCardProps {
  data: WeatherInfoData;
}

const WeatherInfoCard: React.FC<WeatherInfoCardProps> = ({ data }) => {
  return (
    <div className="flex flex-col gap-8 w-full max-w-2xl mx-auto p-4 bg-backgroundColor-white rounded-lg">
      <div className="flex gap-6 text-sm text-textColorGray">
  <div className="w-[45%]">
    <div className="text-start font-semibold">{translate('weatherAndTravel.heading')}</div>
    <div className="text-start">{data?.heading || '---'}</div>
  </div>

  <div className="">
    <div className="text-start font-semibold">{translate('weatherAndTravel.expectedTemp')}</div>
    <div className="text-start">{data?.expectedTemp || '---'}</div>
  </div>

  <div className="flex-1">
    <div className="text-end font-semibold">{translate('weatherAndTravel.ofl')}</div>
    <div className="text-end">{data?.ofl || '--:--'}</div>
  </div>
</div>

      <div className="flex gap-6 text-sm text-textColorGray">
        {/* Row 2 */}
        <div className='w-[45%]'>
          <div className="text-start  font-semibold text-textColorGray">
            {translate('weatherAndTravel.forcastOrStatus')}
          </div>
          <div className="text-start text-textColorGray">
            {data?.forecastStatus || '---'}
          </div>
        </div>
        <div className='flex-1'>
          <div className="text-start font-semibold text-textColorGray">
            {translate('weatherAndTravel.information')}
          </div>
          <div className="text-start text-textColorGray">
            {data?.information || '---'}
          </div>
        </div>
      </div>
      <div className="flex gap-6 text-sm text-textColorGray">
        {/* Row 3 */}
        <div className='w-[45%]'>
          <div className="text-start font-semibold text-textColorGray">
            {translate('weatherAndTravel.note')}
          </div>
          <div className="text-start text-textColorGray">
            {data?.note || '---'}
          </div>
        </div>
        <div>
          <div className="text-start font-semibold text-textColorGray">
            {translate('weatherAndTravel.lastupdate')}
          </div>
          <div className="text-start text-textColorGray">
            {data?.lastUpdated || '---'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherInfoCard;
